import templateMarkup from 'raw-loader!./documentation-view.html';
import ConfigService from "../../../../services/config.service";
import WebResourceSecure from "../../../assurance/services/web-resource-secure.service";
import ko from "knockout";

function DocumentationView(day, callId) {
    var self = this;
    self.initialize(day,  callId);
}

DocumentationView.prototype = {
  initialize: function (params) {
        var self = this;
        self.dataProvider = params.dataProvider;
        self.params = params;
        self.route = params.route;
        self.apidoc = ko.observable();
        self.loadCpmmApi();

        self.subscribe = self.route.subscribe(function() {
          self.scrollToLink();
        });

    },

    loadCpmmApi: function () {
        let self = this;
        ConfigService.getInstance().getAssuranceQueryService().then(function (serviceUrl) {
            var url = serviceUrl + '/docs/cpmm-query-service';
            // WebResourceSecure.getJSON relies on DataProvider.userObj.apiToken being set
            WebResourceSecure.getJSON(url, undefined, undefined, 'html').then(function (dochtml) {
                // todo this no longer works due to security restrictions of inline scripts
                // self.apidoc(dochtml.replace(/href="#([\w-]+)"/g,'onclick="document.getElementById(\'$1\').scrollIntoView();return false;"'));
                // self.apidoc(dochtml);
              self.apidoc(dochtml.replace(/href="#([\w-]+)"/g,'href="/#/dev/api/cpmm/$1" target="_top"'));
              // self.apidoc('data:text/html,' + dochtml);

              document.querySelector('iframe').addEventListener('load', function() {
                self.scrollToLink();
              });
            });
        });
    },

    scrollToLink() {
      let self = this;
      if (self.route().link) {
        document.querySelector('iframe').contentDocument.getElementById(self.route().link).scrollIntoView();
      }
    },

    dispose: function () {
      let self = this;
      if (self.subscribe) {
        self.subscribe.dispose();
      }
    }
};

export default { template: templateMarkup, viewModel: DocumentationView };
